import React, { useEffect } from "react";
import Caartoon from "../../../Img/cartoon.png";
import yellow_Shadow from "../../../Web/yellow_Shadow.png";
import Main_text from "../../../New_Web_design/main_Img.png";
import ScrollToTop from "../ScrollTop";
import Cash_img from "../../../New_Web_design/Cash_img.png";
// import APK from "../../../files/wolfwingames.apk";

export default function Home() {
  const [scrollValue, setSrollValue] = React.useState();
  const [isDevice, setIsDevice] = React.useState();
  const [downloadLink, setDownloadLink] = React.useState();

  const handleScroll = () => {
    const scrollPosition = window.innerWidth;
    setSrollValue(scrollPosition);
  };
  console.log("width:::::::>", scrollValue);
  useEffect(() => {
    handleScroll();
    getOS();

    // getMobileOperatingSystem();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  console.log("isDevice::: ", isDevice);
  const downloadApk = async () => {
    const link = document.createElement("a");
    link.href =
      "https://wolfwinplay-apk.s3.ap-south-1.amazonaws.com/WolfwinCash.apk";
    link.download = "WolfwinCash.apk"; // Set the desired file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  // function getMobileOperatingSystem() {
  //   var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  //   // Windows Phone must come first because its UA also contains "Android"
  //   if (/windows phone/i.test(userAgent)) {
  //     console.log("Windows Phone::: ");
  //     setIsDevice("Windows");
  //     return "Windows Phone";
  //   }

  //   if (/android/i.test(userAgent)) {
  //     setIsDevice("Android");
  //     setDownloadLink("");
  //     return "Android";
  //   }

  //   // iOS detection from: http://stackoverflow.com/a/9039885/177710
  //   if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
  //     setIsDevice("iOS");
  //     setDownloadLink("");
  //     console.log("iOS::: ");
  //     return "iOS";
  //   }
  //   setIsDevice("unknown");
  //   console.log("unknown::: ");
  //   return "unknown";
  // }

  function getOS() {
    var uA = navigator.userAgent || navigator.vendor || window.opera;
    if (
      (/iPad|iPhone|iPod/.test(uA) && !window.MSStream) ||
      (uA.includes("Mac") && "ontouchend" in document)
    )
      setIsDevice("iOS");

    var i,
      os = ["Windows", "Android", "Unix", "Mac", "Linux", "BlackBerry"];
    for (i = 0; i < os.length; i++) {
      if (new RegExp(os[i], "i").test(uA)) setIsDevice(os[i]);
    }
    if (
      isDevice == "Android" ||
      isDevice == "Windows" ||
      isDevice == "Unix" ||
      isDevice == "Linux" ||
      isDevice == "BlackBerry"
    ) {
      console.log("Android::: ");
      setDownloadLink(
        "https://play.google.com/store/apps/details?id=com.wolfwin"
      );
    } else if (isDevice == "Mac" || isDevice == "iOS") {
      console.log("Mac::: ", downloadLink);

      setDownloadLink(
        "https://apps.apple.com/us/app/wolfwin-skill-game-online/id6467877327"
      );
    }
  }

  return (
    <>
      <div id="home" className="liner">
        <ScrollToTop />
        <div className="Homemargin ">
          <div className="container">
            {scrollValue > 820 ? (
              <>
                <div className="row">
                  <div
                    className="col-sm-12 col-md-12 col-lg-6 d-flex"
                    style={{ alignItems: "center" }}
                  >
                    <div>
                      {/* <div style={{ width: "100%" }}>
                    <img src={Cash_img} width="100%" />
                  </div> */}

                      <p
                        className="main-text "
                        style={{
                          fontFamily: "NunitoBlack",
                          lineHeight: "50px",
                          color: "white",
                        }}
                      >
                        {/* Cash on Wolfw<span class="i">i</span>n */}
                        Play Skill Based Games
                      </p>
                      <p
                        className="sub-text mt-4"
                        style={{
                          fontFamily: "JosefinSans",
                          color: "#f9c130",
                        }}
                      >
                        <b>Instantly earn $10 bonus by signing up now!</b>
                      </p>

                      <div className="mt-4">
                        <button
                          style={{
                            color: "white",
                            padding: "20px",
                            borderRadius: "20px",
                            border: "0px",
                            fontSize: "20px",
                            width: "300px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            // if (
                            //   isDevice == "Android" ||
                            //   isDevice == "Windows" ||
                            //   isDevice == "Unix" ||
                            //   isDevice == "Linux" ||
                            //   isDevice == "BlackBerry"
                            // ) {
                            //   console.log("Android::: ");
                            //   window.open(
                            //     "https://play.google.com/store/apps/details?id=com.wolfwin"
                            //   );
                            // } else if (isDevice == "Mac" || isDevice == "iOS") {
                            //   console.log("Mac::: ", downloadLink);
                            //   window.open(
                            //     "https://apps.apple.com/us/app/wolfwin-skill-game-online/id6467877327"
                            //   );
                            // }
                            downloadApk();
                          }}
                          className="buttonColor"
                        >
                          <b style={{ fontFamily: "NunitoBlack" }}>
                            <a
                              style={{
                                textDecoration: "none",
                                color: "white",
                              }}
                            >
                              Get Link Download
                            </a>
                          </b>
                        </button>
                      </div>
                      <div
                        className="col-sm-12 col-md-6 col-lg-6"
                        style={{ alignItems: "center" }}
                      >
                        <div
                          className="d-flex mt-5"
                          style={{
                            alignItems: "center",
                            fontFamily: "NunitoBlack",
                          }}
                        >
                          <p style={{ color: "white", fontSize: "25px" }}>
                            Available Now
                          </p>
                        </div>
                        <div>
                          <div className="d-flex">
                            {/* setIconButton */}
                            <div
                              style={{
                                width: "50px",
                                height: "50px",

                                display: "flex",
                                justifyContent: "center",
                                margin: "17px",
                                cursor: "pointer",
                              }}
                              // onClick={() => {
                              //   downloadApk();
                              // window.open(
                              //   "https://play.google.com/store/apps/details?id=com.wolfwin"
                              // );
                              // }}
                            >
                              <button
                                style={{ background: "none", border: "none" }}
                                onClick={() => {
                                  downloadApk();
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="50"
                                  height="50"
                                  fill="#929498"
                                  class="bi bi-android2"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="m10.213 1.471.691-1.26c.046-.083.03-.147-.048-.192-.085-.038-.15-.019-.195.058l-.7 1.27A4.832 4.832 0 0 0 8.005.941c-.688 0-1.34.135-1.956.404l-.7-1.27C5.303 0 5.239-.018 5.154.02c-.078.046-.094.11-.049.193l.691 1.259a4.25 4.25 0 0 0-1.673 1.476A3.697 3.697 0 0 0 3.5 5.02h9c0-.75-.208-1.44-.623-2.072a4.266 4.266 0 0 0-1.664-1.476ZM6.22 3.303a.367.367 0 0 1-.267.11.35.35 0 0 1-.263-.11.366.366 0 0 1-.107-.264.37.37 0 0 1 .107-.265.351.351 0 0 1 .263-.11c.103 0 .193.037.267.11a.36.36 0 0 1 .112.265.36.36 0 0 1-.112.264Zm4.101 0a.351.351 0 0 1-.262.11.366.366 0 0 1-.268-.11.358.358 0 0 1-.112-.264c0-.103.037-.191.112-.265a.367.367 0 0 1 .268-.11c.104 0 .19.037.262.11a.367.367 0 0 1 .107.265c0 .102-.035.19-.107.264ZM3.5 11.77c0 .294.104.544.311.75.208.204.46.307.76.307h.758l.01 2.182c0 .276.097.51.292.703a.961.961 0 0 0 .7.288.973.973 0 0 0 .71-.288.95.95 0 0 0 .292-.703v-2.182h1.343v2.182c0 .276.097.51.292.703a.972.972 0 0 0 .71.288.973.973 0 0 0 .71-.288.95.95 0 0 0 .292-.703v-2.182h.76c.291 0 .54-.103.749-.308.207-.205.311-.455.311-.75V5.365h-9v6.404Zm10.495-6.587a.983.983 0 0 0-.702.278.91.91 0 0 0-.293.685v4.063c0 .271.098.501.293.69a.97.97 0 0 0 .702.284c.28 0 .517-.095.712-.284a.924.924 0 0 0 .293-.69V6.146a.91.91 0 0 0-.293-.685.995.995 0 0 0-.712-.278Zm-12.702.283a.985.985 0 0 1 .712-.283c.273 0 .507.094.702.283a.913.913 0 0 1 .293.68v4.063a.932.932 0 0 1-.288.69.97.97 0 0 1-.707.284.986.986 0 0 1-.712-.284.924.924 0 0 1-.293-.69V6.146c0-.264.098-.491.293-.68Z" />
                                </svg>
                              </button>
                            </div>
                            <div class="verticalLine"></div>
                            <div id="Games"></div>
                            <div
                              style={{
                                width: "50px",
                                height: "50px",

                                display: "flex",
                                justifyContent: "center",
                                borderRadius: "50%",

                                margin: "17px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                window.open(
                                  "https://apps.apple.com/us/app/wolfwin-skill-game-online/id6467877327"
                                );
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="50"
                                height="50"
                                fill="#929498"
                                class="bi bi-apple"
                                viewBox="0 0 16 16"
                              >
                                <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516.024.034 1.52.087 2.475-1.258.955-1.345.762-2.391.728-2.43Zm3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422.212-2.189 1.675-2.789 1.698-2.854.023-.065-.597-.79-1.254-1.157a3.692 3.692 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56.244.729.625 1.924 1.273 2.796.576.984 1.34 1.667 1.659 1.899.319.232 1.219.386 1.843.067.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758.347-.79.505-1.217.473-1.282Z" />
                                <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516.024.034 1.52.087 2.475-1.258.955-1.345.762-2.391.728-2.43Zm3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422.212-2.189 1.675-2.789 1.698-2.854.023-.065-.597-.79-1.254-1.157a3.692 3.692 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56.244.729.625 1.924 1.273 2.796.576.984 1.34 1.667 1.659 1.899.319.232 1.219.386 1.843.067.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758.347-.79.505-1.217.473-1.282Z" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-6 col-sm-pull-12">
                    <div style={{ height: "110%", width: "100%" }}>
                      <img
                        src={Main_text}
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    {/* <div>
                  <img src={Main_text} className="mainImage" />
                </div> */}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-6 mt-5 col-sm-pull-12">
                    <div style={{ height: "100%", width: "100%" }}>
                      <img
                        src={Main_text}
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    {/* <div>
                  <img src={Main_text} className="mainImage" />
                </div> */}
                  </div>
                  <div
                    className="col-sm-12 col-md-12 col-lg-6 d-flex mt-5"
                    style={{ justifyContent: "center", alignItems: "center" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {/* <div style={{ width: "100%" }}>
                    <img src={Cash_img} width="100%" />
                  </div> */}
                      <div>
                        <p
                          className="main-text text-center"
                          style={{
                            fontFamily: "NunitoBlack",

                            color: "white",
                          }}
                        >
                          Play Skill Based Games
                        </p>
                        <p
                          className="sub-text text-center"
                          style={{
                            fontFamily: "JosefinSans",

                            color: "#f9c130",
                          }}
                        >
                          Instantly earn $10 bonus by signing up now!
                        </p>

                        {/* <h6>{downloadLink}</h6> */}

                        <div
                          className=" mt-5"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <button
                            style={{
                              color: "white",
                              padding: "20px",
                              borderRadius: "20px",
                              border: "0px",
                              cursor: "pointer",
                              width: "300px",
                            }}
                            onClick={() => {
                              // if (
                              //   isDevice == "Android" ||
                              //   isDevice == "Windows" ||
                              //   isDevice == "Unix" ||
                              //   isDevice == "Linux" ||
                              //   isDevice == "BlackBerry"
                              // ) {
                              //   console.log("Android::: ");
                              //   window.open(
                              //     "https://play.google.com/store/apps/details?id=com.wolfwin"
                              //   );
                              // } else if (
                              //   isDevice == "Mac" ||
                              //   isDevice == "iOS"
                              // ) {
                              //   console.log("Mac::: ", downloadLink);
                              //   window.open(
                              //     "https://apps.apple.com/us/app/wolfwin-skill-game-online/id6467877327"
                              //   );
                              // }
                              downloadApk();
                            }}
                            className="buttonColor"
                          >
                            <b style={{ fontFamily: "NunitoBlack" }}>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "white",
                                }}
                              >
                                Get Link Download
                              </a>
                            </b>
                          </button>
                        </div>
                        <div
                          className="col-sm-12 col-md-6 col-lg-6"
                          style={{ alignItems: "center" }}
                        >
                          <div
                            className="d-flex mt-5"
                            style={{
                              justifyContent: "center",
                              alignItems: "center",
                              fontFamily: "NunitoBlack",
                            }}
                          >
                            <p style={{ color: "white", fontSize: "20px" }}>
                              Available Now
                            </p>
                          </div>
                          <div>
                            <div
                              className="d-flex"
                              style={{ justifyContent: "center" }}
                            >
                              {/* setIconButton */}
                              <div
                                style={{
                                  width: "70px",
                                  height: "70px",

                                  display: "flex",

                                  padding: "10px",
                                  cursor: "pointer",
                                }}
                              >
                                <button
                                  style={{
                                    background: "none",
                                    border: "none",
                                    padding: "0px",
                                  }}
                                  onClick={() => {
                                    downloadApk();
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="50"
                                    height="50"
                                    fill="#929498"
                                    class="bi bi-android2"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="m10.213 1.471.691-1.26c.046-.083.03-.147-.048-.192-.085-.038-.15-.019-.195.058l-.7 1.27A4.832 4.832 0 0 0 8.005.941c-.688 0-1.34.135-1.956.404l-.7-1.27C5.303 0 5.239-.018 5.154.02c-.078.046-.094.11-.049.193l.691 1.259a4.25 4.25 0 0 0-1.673 1.476A3.697 3.697 0 0 0 3.5 5.02h9c0-.75-.208-1.44-.623-2.072a4.266 4.266 0 0 0-1.664-1.476ZM6.22 3.303a.367.367 0 0 1-.267.11.35.35 0 0 1-.263-.11.366.366 0 0 1-.107-.264.37.37 0 0 1 .107-.265.351.351 0 0 1 .263-.11c.103 0 .193.037.267.11a.36.36 0 0 1 .112.265.36.36 0 0 1-.112.264Zm4.101 0a.351.351 0 0 1-.262.11.366.366 0 0 1-.268-.11.358.358 0 0 1-.112-.264c0-.103.037-.191.112-.265a.367.367 0 0 1 .268-.11c.104 0 .19.037.262.11a.367.367 0 0 1 .107.265c0 .102-.035.19-.107.264ZM3.5 11.77c0 .294.104.544.311.75.208.204.46.307.76.307h.758l.01 2.182c0 .276.097.51.292.703a.961.961 0 0 0 .7.288.973.973 0 0 0 .71-.288.95.95 0 0 0 .292-.703v-2.182h1.343v2.182c0 .276.097.51.292.703a.972.972 0 0 0 .71.288.973.973 0 0 0 .71-.288.95.95 0 0 0 .292-.703v-2.182h.76c.291 0 .54-.103.749-.308.207-.205.311-.455.311-.75V5.365h-9v6.404Zm10.495-6.587a.983.983 0 0 0-.702.278.91.91 0 0 0-.293.685v4.063c0 .271.098.501.293.69a.97.97 0 0 0 .702.284c.28 0 .517-.095.712-.284a.924.924 0 0 0 .293-.69V6.146a.91.91 0 0 0-.293-.685.995.995 0 0 0-.712-.278Zm-12.702.283a.985.985 0 0 1 .712-.283c.273 0 .507.094.702.283a.913.913 0 0 1 .293.68v4.063a.932.932 0 0 1-.288.69.97.97 0 0 1-.707.284.986.986 0 0 1-.712-.284.924.924 0 0 1-.293-.69V6.146c0-.264.098-.491.293-.68Z" />
                                  </svg>
                                </button>
                              </div>
                              <div class="verticalLine"></div>
                              <div
                                style={{
                                  width: "70px",
                                  height: "70px",

                                  display: "flex",

                                  borderRadius: "50%",

                                  padding: "15px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  window.open(
                                    "https://apps.apple.com/us/app/wolfwin-skill-game-online/id6467877327"
                                  );
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="50"
                                  height="50"
                                  fill="#929498"
                                  class="bi bi-apple"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516.024.034 1.52.087 2.475-1.258.955-1.345.762-2.391.728-2.43Zm3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422.212-2.189 1.675-2.789 1.698-2.854.023-.065-.597-.79-1.254-1.157a3.692 3.692 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56.244.729.625 1.924 1.273 2.796.576.984 1.34 1.667 1.659 1.899.319.232 1.219.386 1.843.067.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758.347-.79.505-1.217.473-1.282Z" />
                                  <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516.024.034 1.52.087 2.475-1.258.955-1.345.762-2.391.728-2.43Zm3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422.212-2.189 1.675-2.789 1.698-2.854.023-.065-.597-.79-1.254-1.157a3.692 3.692 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56.244.729.625 1.924 1.273 2.796.576.984 1.34 1.667 1.659 1.899.319.232 1.219.386 1.843.067.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758.347-.79.505-1.217.473-1.282Z" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            <div id="Games"></div>
          </div>
        </div>
      </div>
    </>
  );
}
